import {ISpineButtonConfig, Size2D, SlotConfig, SpineConfig} from '@gongxigames/framework/core';

type PopupAnimation = string | PopupTypedAnimation[];

export type GenericPopupData<T = {}> = {
    type: Symbol;
    counterValue?: GenericPopupCounterValue;
    specialData?: T;
};

export type GenericPopupShowData = {
    type: Symbol;
    value?: string;
    args?: any[];
};

export type GenericPopupCounterValue = {
    to: number;
    from?: number;
    duration?: number;
    type?: number;
};

export type PopupTypedAnimation = {
    name: string;
    type: number;
    sound?: string;
};

export type PopupAnimations = {
    start?: PopupAnimation;
    idle?: PopupAnimation;
    skin?: string;
};

export type ButtonSlotConfig = SlotConfig & {
    enableEvent?: string;
};

export type PopupSpineConfig = {
    spine: SpineConfig;
    animation?: PopupAnimations;
    continueButton?: ButtonSlotConfig;
    value?: SlotConfig;
    counter?: SlotConfig;
};

export type PopupFaderColorConfig = {
    color: number;
    alpha: number;
    fadeDuration?: number;
};

export type PopupFaderImgConfig = {
    img: string;
    alpha?: number;
    width?: number;
    height?: number;
    fadeDuration?: number;
};

export type SpinePopupAnimationConfig = {
    name: string;
    skin?: string;
};

export type PopupFaderSpineConfig = {
    spine: SpineConfig;
    fadeDuration?: number;
    width: number;
    height: number;
    start?: SpinePopupAnimationConfig;
    idle: SpinePopupAnimationConfig;
};

export type PopupFaderConfig = PopupFaderColorConfig | PopupFaderImgConfig | PopupFaderSpineConfig;

export type GenericPopupConfig = {
    view: symbol;
    type: symbol;
    emitType?: symbol;
    spine: PopupSpineConfig[];
    size?: Size2D;
    soundConfig: {
        exit?: string;
        waiting?: string;
        transitionEnter?: string;
        buttonClickSound?: string;
    };
    actionButton?: ISpineButtonConfig;
    startTimeout?: number;
    closeTimeout?: number;
    fader?: PopupFaderConfig;
};
